function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, withHandlers, withProps, withPropsOnChange, withStateHandlers } from 'recompose';
import { createBrowserHistory as createHistory } from 'history';
import { getNoteTemplateCategories as api_getNoteTemplateCategories, getNoteTemplateVariables as api_getNoteTemplateVariables, renderNoteTemplate as api_renderNoteTemplate } from "../../api/noteTemplates";
import { setNoteTemplateCategoriesLoading, setNoteTemplateCategories, setNoteTemplateVariables, noteTemplatesFilterSetSearch, noteTemplateCategories, noteTemplateFilterVisible, noteTemplateVariables, noteTemplatesFilterArchive, noteTemplatesFilterCategories, noteTemplatesFilterForAgents, noteTemplatesFilterForStudents, noteTemplatesFilterRestricted, noteTemplatesFilterSearch, noteTemplatesFilterTags, noteTemplatesFilterTemplateTypes, applicationCurrentApplicationSelector, permissionsSelector } from '@applyboard/ab-common';
import handleApiErrorResponse from "../../util/handleApiErrorResponse";
import { getNoteTemplatesAction, getNoteTemplatesTagDefinitionsAction, createNoteTemplateAction, editNoteTemplateAction, destroyNoteTemplateAction } from "../../api/jsonapi";
import lazyLoad from "../../util/lazyLoad";
import getApiObjectList from "../../util/getApiObjectList";
import memoized from "../../util/memoized";
import raiseSuccessMessage from "../../util/raiseSuccessMessage";
import showErrors from "../../util/showErrors";
var history = createHistory();
var TEMPLATE_ROUTE = '/notes/templates';
var generateTagOptions = memoized(function (note_templates_tag_definitions) {
  try {
    return note_templates_tag_definitions.map(function (entry) {
      return {
        label: entry.attributes.name,
        value: parseInt(entry.id, 10)
      };
    });
  } catch (e) {
    /* intentionally left blank */
  }
  return [];
});
var retrieveTagsForTemplate = function retrieveTagsForTemplate(template, tags, note_templates_tag_definitions) {
  if (!tags || !note_templates_tag_definitions) return [];
  try {
    var tag_options = generateTagOptions(note_templates_tag_definitions);
    var tag_ids = template.relationships.tags.data.map(function (e) {
      return parseInt(e.id, 10);
    });
    var tag_elements = tag_ids.map(function (id) {
      return tags.find(function (e) {
        return e.id === id;
      });
    });
    var tag_names = tag_elements.map(function (e) {
      return e.name;
    });
    var template_tag_options = tag_options.filter(function (e) {
      return tag_names.indexOf(e.label) >= 0;
    });
    return template_tag_options;
  } catch (e) {
    /* intentionally left blank */
  }
  return [];
};
var getNoteTemplatesFromState = function getNoteTemplatesFromState(state, currentList) {
  try {
    var ids = currentList ? currentList.map(function (e) {
      return e.id;
    }) : [];
    var templates = state.api.entities.note_templates;
    return ids.map(function (key) {
      return templates[key];
    }).filter(Boolean);
  } catch (e) {
    /* intentionally left blank */
  }
  return null;
};

/* Common Redux Enhancers */

export var getCurrentApplicationEnhancer = connect(createStructuredSelector({
  application: applicationCurrentApplicationSelector
}));
export var getCurrentPermissionsEnhancer = connect(createStructuredSelector({
  permissions: permissionsSelector
}));
export var getNoteTemplatesEnhancer = compose(connect(createStructuredSelector({
  filter_archived: noteTemplatesFilterArchive,
  filter_categories: noteTemplatesFilterCategories,
  filter_for_agents: noteTemplatesFilterForAgents,
  filter_for_students: noteTemplatesFilterForStudents,
  filter_restricted: noteTemplatesFilterRestricted,
  filter_search: noteTemplatesFilterSearch,
  filter_tags: noteTemplatesFilterTags,
  filter_template_types: noteTemplatesFilterTemplateTypes,
  filter_visible: noteTemplateFilterVisible
}), function () {
  return {};
}), lazyLoad('note_templates_list', getNoteTemplatesAction, function (func, _ref) {
  var filter_archived = _ref.filter_archived,
    filter_search = _ref.filter_search,
    filter_tags = _ref.filter_tags,
    filter_categories = _ref.filter_categories,
    filter_for_agents = _ref.filter_for_agents,
    filter_for_students = _ref.filter_for_students,
    filter_restricted = _ref.filter_restricted,
    filter_template_types = _ref.filter_template_types;
  var query = {};
  if (filter_search) query.q = filter_search;
  if (Array.isArray(filter_tags) && filter_tags.length > 0) {
    query.tags = filter_tags.map(function (e) {
      return e.value;
    }).join(',');
  }
  if (Array.isArray(filter_categories) && filter_categories.length > 0) {
    query.categories = filter_categories.map(function (e) {
      return e.value;
    }).join(',');
  }
  if (filter_for_agents) query.for_agents = filter_for_agents;
  if (filter_for_students) query.for_students = filter_for_students;
  if (filter_restricted) query.restricted = filter_restricted;
  if (filter_archived) query.archived = filter_archived;
  if (Array.isArray(filter_template_types) && filter_template_types.length > 0) {
    query.template_types = filter_template_types.join(',');
  }
  return func(query);
}), lazyLoad('note_templates_tag_definitions', getNoteTemplatesTagDefinitionsAction), getApiObjectList('tags'),
/*
  purposely overrides the response from the lazyLoad to account for state
  changes when creating new notes templates.
*/
connect(function (state, _ref2) {
  var note_templates_list = _ref2.note_templates_list;
  return {
    note_templates_list: getNoteTemplatesFromState(state, note_templates_list)
  };
}), withProps(function (_ref3) {
  var status = _ref3.status,
    note_templates_list = _ref3.note_templates_list,
    note_templates_tag_definitions = _ref3.note_templates_tag_definitions,
    tags = _ref3.tags;
  return {
    isNoteTemplatesLoaded: status && status.note_templates_list ? status.note_templates_list.hasStarted && !status.note_templates_list.isLoading : false,
    noteTemplates: note_templates_list ? note_templates_list.map(function (entry) {
      return _objectSpread(_objectSpread({}, entry), {}, {
        attributes: _objectSpread(_objectSpread({}, entry.attributes), {}, {
          tags: retrieveTagsForTemplate(entry, tags, note_templates_tag_definitions)
        })
      });
    }) : null,
    note_templates_tag_definitions: generateTagOptions(note_templates_tag_definitions),
    loading: !status || !status.note_templates_list || status.note_templates_list.isLoading
  };
}), withPropsOnChange(['noteTemplates'], function (_ref4) {
  var noteTemplates = _ref4.noteTemplates;
  return {
    filteredNoteTemplates: noteTemplates || []
  };
}), withHandlers({
  reloadNoteTemplates: function reloadNoteTemplates(_ref5) {
    var status = _ref5.status;
    return function () {
      var _status$note_template;
      if (!(status !== null && status !== void 0 && status.note_templates_list)) {
        console.error('cannot reload note templates');
        return;
      }
      var _ref6 = (_status$note_template = status === null || status === void 0 ? void 0 : status.note_templates_list) !== null && _status$note_template !== void 0 ? _status$note_template : {},
        refetch = _ref6.refetch,
        invalidate = _ref6.invalidate;
      invalidate();
      refetch();
    };
  }
}));
export var getNoteTemplateCategoriesEnhancer = connect(createStructuredSelector({
  noteTemplateCategories: noteTemplateCategories
}), function (dispatch) {
  return {
    getNoteTemplateCategories: function getNoteTemplateCategories() {
      return dispatch( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
          var currentState, _currentState$noteTem, isLoading, isLoaded, categories;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                currentState = getState();
                _currentState$noteTem = currentState.noteTemplates, isLoading = _currentState$noteTem.isLoading, isLoaded = _currentState$noteTem.isLoaded;
                if (!(isLoading || isLoaded)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                _context.prev = 4;
                dispatch(setNoteTemplateCategoriesLoading(true));
                _context.next = 8;
                return api_getNoteTemplateCategories();
              case 8:
                categories = _context.sent;
                dispatch(setNoteTemplateCategories(categories.data));
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                showErrors(_context.t0);
              case 15:
                dispatch(setNoteTemplateCategoriesLoading(false));
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[4, 12]]);
        }));
        return function (_x, _x2) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  };
});
export var getNoteTemplateVariablesEnhancer = connect(createStructuredSelector({
  noteTemplateVariables: noteTemplateVariables
}), function (dispatch) {
  return {
    getNoteTemplateVariables: function () {
      var _getNoteTemplateVariables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var variables;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return api_getNoteTemplateVariables();
            case 3:
              variables = _context2.sent;
              dispatch(setNoteTemplateVariables(variables.data));
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              showErrors(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }));
      function getNoteTemplateVariables() {
        return _getNoteTemplateVariables.apply(this, arguments);
      }
      return getNoteTemplateVariables;
    }()
  };
});
export var modifyNoteTemplatesEnhancer = connect(null, function (dispatch) {
  return {
    saveNoteTemplate: function saveNoteTemplate(data) {
      var call = data.id && data.id > 0 ? editNoteTemplateAction : createNoteTemplateAction;
      return dispatch(call({
        id: data.id
      }, {
        data: {
          attributes: data
        }
      })).then(function (res) {
        raiseSuccessMessage('Note template saved');
        return res;
      })["catch"](handleApiErrorResponse);
    },
    deleteNoteTemplate: function deleteNoteTemplate(id) {
      return dispatch(destroyNoteTemplateAction({
        id: id,
        type: 'note_templates',
        method: 'destroy'
      })).then(function (res) {
        raiseSuccessMessage('Note template deleted');
        return res;
      })["catch"](handleApiErrorResponse);
    }
  };
});

/* Common Logic Enhancers */

export var searchEnhancer = connect(function (state) {
  return {
    searchValue: noteTemplatesFilterSearch(state),
    filter_visible: noteTemplateFilterVisible(state)
  };
}, function (dispatch) {
  return {
    onSearchValueChange: function onSearchValueChange(event) {
      return dispatch(noteTemplatesFilterSetSearch(event.target.value));
    }
  };
});
export var selectableTemplatesEnhancer = withStateHandlers({
  selectedTemplate: null
}, {
  unselectTemplate: function unselectTemplate() {
    return function () {
      return {
        selectedTemplate: null
      };
    };
  },
  selectTemplate: function selectTemplate() {
    return function (selectedTemplate) {
      return {
        selectedTemplate: selectedTemplate
      };
    };
  },
  onSelectTemplate: function onSelectTemplate() {
    return function (template) {
      // update the query string in the url
      if (window.location.pathname.indexOf(TEMPLATE_ROUTE) === 0) {
        history.replace("".concat(TEMPLATE_ROUTE, "?template_id=").concat(template.id));
      }
      return {
        selectedTemplate: template
      };
    };
  },
  selectTemplateWithId: function selectTemplateWithId(state, _ref8) {
    var noteTemplates = _ref8.noteTemplates;
    return function (id) {
      if (!noteTemplates || !id) {
        console.warn('selectTemplateWithId: cannot select template', id, noteTemplates);
        return {
          selectedTemplate: null
        };
      }
      var numeric_id = parseInt(id, 10);
      var template = noteTemplates.find(function (t) {
        return parseInt(t.id, 10) === numeric_id;
      });
      if (!template) {
        console.warn('selectTemplateWithId: cannot find template with id', id, noteTemplates);
        return {
          selectedTemplate: null
        };
      }
      return {
        selectedTemplate: _objectSpread({
          id: template.id,
          type: template.type
        }, template.attributes)
      };
    };
  }
});
export var renderNoteTemplateEnhancer = withHandlers({
  renderNoteTemplate: function renderNoteTemplate() {
    return /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id, applicationId) {
        var text;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return api_renderNoteTemplate(id, applicationId);
            case 3:
              text = _context3.sent;
              return _context3.abrupt("return", text.data);
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              showErrors(_context3.t0);
              return _context3.abrupt("return", null);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
      return function (_x3, _x4) {
        return _ref9.apply(this, arguments);
      };
    }();
  }
});